<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!territorySelected) {
        <h1 class="title">Crear Territorio</h1>
      }
    </div>
    <div class="title-color">
      @if (territorySelected) {
        <h1 class="title">Editar Territorio</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="territoryForm" (ngSubmit)="saveTerritory()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (territoryForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (territoryForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>NIT</mat-label>
              <input
                type="text"
                matInput
                placeholder="NIT"
                formControlName="nit"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (territoryForm.get('nit')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (territoryForm.get('nit')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Zona</mat-label>
              <input
                type="text"
                matInput
                placeholder="Zona"
                formControlName="zone"
                maxlength="256"
                oninput="this.value = this.value.toUpperCase()"
              />
              <!-- @if (territoryForm.get('zone')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              } -->
              @if (territoryForm.get('zone')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Resolución</mat-label>
              <input
                type="text"
                matInput
                placeholder="Resolución"
                formControlName="resolution"
                maxlength="256"
                oninput="this.value = this.value.toUpperCase()"
              />
              <!-- @if (territoryForm.get('resolution')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              } -->
              @if (territoryForm.get('resolution')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Representante Legal</mat-label>
              <input
                type="text"
                matInput
                placeholder="Representante Legal"
                formControlName="legalRepresentation"
                maxlength="256"
                oninput="this.value = this.value.toUpperCase()"
              />
              <!-- @if (territoryForm.get('legalRepresentation')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              } -->
              @if (territoryForm.get('legalRepresentation')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <div class="search-select-container">
              <app-search-select
                [dataList]="lifeplanSelected"
                [initialValue]="getLifeplanValue()"
                placeholder="Plan de vida"
                label="Plan de vida"
                noResults="Sin resultados"
                (onSelectOption)="onLifeplanSelected($event)"
              >
              </app-search-select>
            </div>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!territoryForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
